import { ApiLabelLabel } from '../types/contentTypes'

function getLocalizedEntries(json: any, lang: any) {
  const localizedDataArray = json.data.map((mainData: any) => {
    const localizedData = mainData.attributes.localizations.data.find((loc: ApiLabelLabel) => loc.attributes.locale === lang)

    if (localizedData) {
      // debugger
      return {
        id: localizedData.id,
        attributes: {
          ...mainData.attributes,
          ...localizedData.attributes
        }
      }
    }

    // Return the main data if the specified language is not found
    return {
      id: mainData.id,
      attributes: mainData.attributes
    }
  })

  return {
    data: localizedDataArray,
    meta: json.meta // Ensure meta is included
  }
}

export default getLocalizedEntries